<template>
  <div class="intervento-elenco">
    <div class="title_h1 yo-color-secondary">{{ giorno  | datetime('LL') }}</div>
    <div class="evento" v-for="evento in sezione" v-on:click="$router.push('/educational-workshops-dettaglio/'+evento.id)" :key="evento.id">
  
        <div class="row pad">
          <div class="col s12 m2 l1"><img class="yo-width-full" :src="'/2019/images/sponsor/'+evento.note.split(' ')[0].toLowerCase()+'.png'" /></div>
          <div class="col s12 m10 l11">
            {{ evento.giorno+' '+evento.inizio  | datetime('HH:mm') }} - {{ evento.giorno+' '+evento.fine  | datetime('HH:mm') }} in {{evento.sala}}
            <div style="font-weight:bold;margin:4px 0 8px 0;">{{evento.titolo}}</div>
            <interventoOspiti :programma="evento.id" ruolo="moderatore"/>
            <br />
            <interventoOspiti :programma="evento.id" ruolo="relatore"/>
          </div>

          <div class="col s12">
            <interventoDettaglio :eventoid="evento.id" />
          </div>
        </div>

    </div>     
  </div>
</template>

<script>
import interventoOspiti from './Intervento-ospiti.vue'
import interventoDettaglio from './Educational-workshops-dettaglio.vue'

var moment = require('moment');
moment.locale('en');
export default {
  name: 'intervento-elenco',
  components: {
    interventoOspiti
    ,interventoDettaglio
  },
  props:{
    giorno: ''
    ,tipologia: ''
  },
  computed: { 
      sezione: function () {
        var isFilter = []
        console.log("................................................")
        console.log(this.$teras._programma)
       if(typeof this.$teras._programma == 'undefined')
         return isFilter

        if(this.$route.params.sezione=='')
          return this.$teras._programma
       

        for (let item of this.$teras._programma){
            //console.log(item.mainsession + ' | '+item.mainsession.toLowerCase())
            if(
              item.parent==0 && 
              item.giorno.toLowerCase().indexOf(this.giorno) > -1 && 
                (item.tipologia.toLowerCase().indexOf(this.tipologia.toLowerCase()) > -1 
                //|| item.tiposessione.toLowerCase().indexOf(this.$route.params.sezione.toLowerCase()) > -1 
                //|| item.tiposessione.toLowerCase().indexOf(this.$route.params.sezione.toLowerCase()) > -1
                )
            )
            isFilter.push(item)
        }
        return isFilter
      }
      
  },
  methods:{
    finterventi(id){
        var isFilter = []
        for (let item of this.$teras.interventi){
            console.log(item)
            if(item.parent == id)
                isFilter.push(item)
        }
        return isFilter
    }
  },
  filters: {
    datetime (value,formato) {
        return moment(value).format(formato)
    },
    citta (value) {
        if(value!=''){
            value = ' ('+value+')'
        }
        return value
    }
  }
}
</script>


<style>
.evento{
    margin-bottom:40px;
    cursor:pointer;
}span.ospite:not(:last-child):after {
    content:', ';
}

</style>
